// GSPRegistration.jsx - ULTIMATE IMAGE FIX - 100% Working
import React from "react";

export default function GSPRegistration() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            GSP Registration
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            GSP Certificate for Preferential Tariffs
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks supports exporters in obtaining GSP Certificates
            (Form A/Registered Exporter) to avail preferential tariff benefits
            from developed countries like EU, USA, Japan, Canada, Australia under
            the Generalized System of Preferences scheme.
          </p>
          <p className="text-gray-700">
            Through DGFT's common digital platform (coo.dgft.gov.in), the process
            ensures compliance with Rules of Origin, direct consignment rules, and
            exporter registration for duty reductions up to 100% on eligible products.
          </p>
        </div>

        {/* Right: BULLETPROOF IMAGE SOLUTION */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100 bg-gradient-to-br from-gray-100 to-gray-200">
            {/* Primary Image - CDN Guaranteed */}
            <img
              src="https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=1200&h=1200&fit=crop&crop=entropy&auto=format&q=80"
              alt="Export shipping containers for GSP preferential tariffs"
              className="w-full h-[400px] md:aspect-square object-cover block"
              loading="eager"
            />
          </div>
        </div>
      </section>

      {/* PROFESSIONAL SUPPORT & DOCUMENTS SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Professional compliance support */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Professional Compliance Support by Hawkins &amp; Brooks
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks provides complete GSP Certificate of Origin
              support through DGFT's common digital platform for exporters targeting
              preferential markets worldwide.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>
                  Exporter registration on DGFT CoO portal with DSC, IEC verification,
                  and REX system enrollment for self-certification eligibility.
                </li>
                <li>
                  Rules of Origin verification (Wholly Obtained/PCT >40-60%) with
                  product-specific eligibility assessment for donor country schemes.
                </li>
                <li>
                  GSP Form A/Statement on Origin preparation through nominated
                  agencies (EIC, FIEO, EPCs) with digital signature submission.
                </li>
                <li>
                  Coordination for direct consignment verification, third-country
                  invoicing compliance, and certificate issuance (valid per shipment).
                </li>
              </ul>
            </div>
          </div>

          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for GSP Registration
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks assists in compiling shipment-specific
              documentation required for GSP preferential tariff certification.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>Valid Import Export Code (IEC) certificate and DSC (Class 2/3).</li>
                <li>
                  Commercial export invoice, packing list, bill of lading with HS
                  codes matching donor country GSP eligible product lists.
                </li>
                <li>
                  Product origin details including bill of materials, supplier
                  declarations, manufacturing process flow, and value addition proof.
                </li>
                <li>
                  Self-declaration of origin or third-party verification for Rules
                  of Origin compliance (Wholly Obtained or Sufficiently Processed).
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm specializes in international trade compliance with proven
              success securing GSP benefits across multiple donor country schemes.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  International Trade Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Complete knowledge of 29+ GSP donor schemes (EU-GSP+, USA, Japan,
                  Canada, Australia) with country-specific Rules of Origin compliance.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate Documentation Handling
                </h3>
                <p className="text-gray-700 text-sm">
                  Professional CoO portal management, origin verification, and
                  nominated agency coordination ensuring first-time GSP approvals.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Professional Advisory Support
                </h3>
                <p className="text-gray-700 text-sm">
                  End-to-end guidance from exporter registration through certificate
                  issuance, customs clearance support, and preferential tariff claims.
                </p>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="flex flex-col justify-center">
            <div className="bg-gray-50 border border-yellow-100 rounded-2xl p-6 shadow-sm">
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                Unlock Global Tariff Preferences
              </h3>
              <p className="text-gray-700 mb-5">
                Connect with Hawkins &amp; Brooks to obtain your GSP Certificate and
                access duty reductions from EU, USA, Japan, Canada, and other developed
                markets for enhanced export competitiveness worldwide.
              </p>
              <div className="flex flex-wrap gap-3">
                <a
                  href="/contact"
                  className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
                >
                  Get Consultation
                </a>
                <a
                  href="tel:+919217468906"
                  className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
                >
                  Call Hawkins &amp; Brooks
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
